export default __webpack_public_path__ + "static/media/Large-Turquoise-Beads-Diffuser-Stretch-Bracelet.7c2760b9.jpg";